export default "__VITE_ASSET__BlITyh01__"